import styles from "./wizard.module.scss";
//import { Typography } from "@mui/material";
import { Route } from "react-router-dom";
import Individual from "./Individual";
import Household from "./Household";
//import Menu from "./components/Menu";
import BottomBar from "./components/BottomBar";
import Checkout from "features/checkout/Checkout";

const Wizard = () => {  
  return (
    <>
      <div className={`${styles.home} row justify-content-center`}>
        {/*
          <div className="col-12 text-center mb-4"> 
            <span className={`${styles.emoji}`}>🌳 <strong>🌳</strong> 🌳</span>
            <Typography variant="h3">
              Offset your emissions by<br/> planting <span>Real Trees</span>
            </Typography>
          </div>
        */}
        {/*<Menu/>*/}
        <div className="col-xl-8 col-lg-10 col-md-12 mb-4"> 
          <Route
            exact
            path={"/"}
            render={(props) => <Individual {...props}/>}
          />
          <Route
            exact
            path={"/individual"}
            render={(props) => <Individual {...props}/>}
          />
          <Route
            exact
            path={"/household"}
            render={(props) => <Household {...props}/>}
          />
        </div>
      </div>
      <BottomBar/>
      <Checkout/>
    </>
  );
};
export default Wizard;
